<template>
  <div>
    <div v-if="initialLoading" class="d-flex justify-content-center mt-3">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">
        Loading...
      </div>
    </div>
    <div v-if="!initialLoading">
      <div class="shadow-card mobile-top" style="position: relative">
        <div class="back-button">
          <span
            @click="$router.go(-1)"
            :style="{ color: getPrimaryColor(), cursor: 'pointer' }"
          >
            <font-awesome-icon
              class="mr-2"
              :style="{ color: getPrimaryColor() }"
              :icon="['fas', 'arrow-left']"
            />
            Back</span
          >
        </div>
        <div :style="{ display: 'flex', alignItems: 'center' }">
          <a-avatar
            :style="{
              color: ' #ffffff !important',
              backgroundColor: revieweeData.image
                ? ''
                : reviews.results[0].review_color
                ? `#${reviews.results[0].review_color}`
                : getAvatarColor(revieweeData.id),
              fontSize: '20px',
              fontWeight: '900'
            }"
            :src="revieweeData.image"
            alt="profile_image"
            :size="70"
            class="text-capitalize cp"
          >
            {{ revieweeData.name ? revieweeData.name[0] : "D"
            }}{{
              revieweeData.name &&
              revieweeData.name
                .split(" ")
                .slice(1)
                .join(" ")
                ? revieweeData.name
                    .split(" ")
                    .slice(1)
                    .join(" ")[0]
                : ""
            }}
          </a-avatar>
          <div :style="{ flex: 1 }">
            <p class="text-name cp" :style="{ marginBottom: '0px' }">
              {{ revieweeData.name || "User" }}
            </p>
            <div
              class="text-day"
              :style="{
                background: '#FFF0D6',
                borderRadius: '4px',
                color: '#F5A623',
                padding: '3px 8px',
                width:
                  type === 'clinic'
                    ? '65px'
                    : type === 'ohcp'
                    ? '200px'
                    : '85px',
                height: '22px'
              }"
            >
              <font-awesome-icon
                v-if="type === 'physician'"
                size="lg"
                style="transform: scale(0.7)"
                :icon="['fal', 'user-md']"
              />
              <font-awesome-icon
                v-if="type === 'hospital'"
                size="lg"
                style="transform: scale(0.7)"
                :icon="['fal', 'hospital-alt']"
              />
              <font-awesome-icon
                v-if="type === 'ohcp'"
                size="lg"
                style="transform: scale(0.7)"
                :icon="['fal', 'hospital-symbol']"
              />
              <font-awesome-icon
                v-if="type === 'clinic'"
                size="lg"
                style="transform: scale(0.7)"
                :icon="['fal', 'hospital']"
              />
              {{
                type
                  ? `${
                      type === "ohcp"
                        ? "Advanced Practice Provider"
                        : type.charAt(0).toUpperCase() + type.slice(1)
                    } `
                  : ""
              }}
            </div>
          </div>
          <div class="detail-container">
            <div>
              <div style="display: flex; justify-content: center">
                <div
                  class="star-container"
                  :style="{
                    background: getPrimaryColor()
                  }"
                >
                  <font-awesome-icon
                    size="2x"
                    style="transform: scale(0.7); width: 24px; height: 24px; color: white"
                    :icon="['fas', 'star']"
                  />
                </div>
                <p class="review-text">
                  {{ parseFloat(reviews.results[0].overall).toFixed(1) }}
                </p>
              </div>
              <p class="review-subtext">Overall Rating</p>
            </div>
            <a-divider type="vertical" style="height: 50px; margin: 0px 40px" />
            <div>
              <div style="display: flex; justify-content: center">
                <p class="review-text" style="margin-left: 0px">
                  {{ reviews.count }}
                </p>
              </div>
              <p class="review-subtext">Reviews</p>
            </div>
          </div>
        </div>
        <div class="detail-container-mobile">
          <div style="flex: 1">
            <div style="display: flex; justify-content: center">
              <div
                class="star-container"
                :style="{
                  background: getPrimaryColor()
                }"
              >
                <font-awesome-icon
                  size="2x"
                  style="transform: scale(0.7); width: 24px; height: 24px; color: white"
                  :icon="['fas', 'star']"
                />
              </div>
              <p class="review-text">
                {{ parseFloat(reviews.results[0].overall).toFixed(1) }}
              </p>
            </div>
            <p class="review-subtext">Overall Rating</p>
          </div>
          <a-divider type="vertical" style="height: 50px; margin: 0px 40px" />
          <div style="flex: 1">
            <div style="display: flex; justify-content: center">
              <p class="review-text" style="margin-left: 0px">
                {{ reviews.count }}
              </p>
            </div>
            <p class="review-subtext">Reviews</p>
          </div>
        </div>
        <!-- <p
          v-if="revieweeType === 'Physician' || revieweeType === 'Advanced medical professional'"
          class="text-name"
          :style="{
            marginBottom: '16px',
            marginLeft: '0px',
            marginTop: '24px',
          }"
        >
          Review type
        </p>
        <div v-if="revieweeType === 'Physician' || revieweeType === 'Advanced medical professional'">
          <a-radio-group v-model:value="filterType" @change="fetchIndividualReviews" class="radio-group">
            <a-radio :value="''">All</a-radio>
            <a-radio :value="'InPerson'">Practice Visit</a-radio>
            <a-radio :value="'MyCircles'">Online Consultation</a-radio>
            <a-radio :value="'Online'">TeleMedicine</a-radio>
          </a-radio-group>
        </div> -->
        <div v-if="loadingScreen" class="spinnerContainer-post">
          <a-spin size="large" />
        </div>
      </div>
      <div v-if="loading" class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div
          :style="{
            'margin-left': '-14px',
            'margin-top': '40px',
            marginBottom: '40px'
          }"
        >
          Loading...
        </div>
      </div>
      <div
        v-if="reviews.results.length === 0 && !loading"
        style="text-align: center; padding: 20px"
      >
        No Reviews
      </div>
      <div class="page-container">
        <div v-if="reviews.results.length != 0 && !loading" class="page-info">
          <p class="result-length">
            {{ reviews.count }}{{ reviews.count > 1 ? " Results" : " Result" }}
          </p>
          <a-dropdown
            style="margintop: 7px"
            :trigger="['click']"
            :getPopupContainer="trigger => trigger.parentNode"
          >
            <p class="sort-text">
              Show
              <span style="font-weight: 700">{{ sortList[sortKey] }}</span>
              <font-awesome-icon
                size="lg"
                style="margin-left: 8px"
                :icon="['fas', 'angle-down']"
              />
            </p>
            <template #overlay>
              <a-menu @click="e => sortReviews(e.key)">
                <a-menu-item key="-published">Newest First</a-menu-item>
                <a-menu-item key="published">Oldest First</a-menu-item>
                <a-menu-item key="-overall">Highest Rated First</a-menu-item>
                <a-menu-item key="nearest">Nearest To You</a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
        <ReviewTabCoreCard
          v-if="reviews.results.length != 0 && !loading"
          v-for="review in reviews.results"
          :reviewData="review"
          :type="type"
          :key="review.id"
        />
        <div
          v-if="reviews.results.length != 0 && !loading && reviews.count > page_size"
          :style="{
            padding: '30px',
            display: 'flex',
            justifyContent: 'center'
          }"
        >
          <a-pagination
            v-model="currentPage"
            class="dovemed-custom-pagination"
            :total="reviews.count"
            show-less-items
            :pageSize="page_size"
            @change="fetchIndividualReviews"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewTabCoreCard from "./ReviewTabCoreCard.vue";
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";

const ReviewsRepository = RepositoryFactory.get("reviews");
const UserRepository = RepositoryFactory.get("user");

export default {
  name: "ReviewsPhysician",

  components: {
    ReviewTabCoreCard
  },

  data() {
    return {
      initialLoading: true,
      reviews: {},
      reviewee_id: null,
      loading: true,
      currentPage: 1,
      filterType: "",
      name: null,
      title: null,
      image: null,
      revieweeType: null,
      overall_rating: null,
      total_reviews: null,
      sortKey: "-published",
      sortList: {
        "-published": "Newest First",
        "published": "Oldest First",
        "-overall": "Highest Rated First",
        nearest: "Nearest To You"
      },
      loadingScreen: false,
      review: null,
      type: null,
      revieweeData: null,
      page_size: 10,
    };
  },

  created() {
    this.reviewee_id = this.$route.params.id;
    this.type = this.$route.params.type;
    this.fetchIndividualReviews();
  },
  methods: {
    sortReviews(sort) {
      this.sortKey = sort;
      this.fetchIndividualReviews();
    },
    fetchIndividualReviews() {
      this.loading = true;
      document.body.scrollTop = 0;
      const headers = {
        Authorization: `Basic ${btoa("dovemed:dovemed-rules")}`,
        dtoken:
          this.authUser.user.dovemed_csrf_token ||
          this.authUser.user.dovemed_session_token
      };
      ReviewsRepository.getIndividualCoreReviews(
        headers,
        this.type,
        this.reviewee_id,
        this.currentPage,
        this.sortKey,
        this.page_size
      )
        .then(res => {
          if (res.data.results.length) {
            this.reviews = res.data;
            this.revieweeData = this.getReviewee();
          } else {
            this.reviews["results"] = [];
          }
          this.loading = false;
          this.initialLoading = false;
        })
        .catch(err => {
          this.reviews["results"] = [];
          this.loading = false;
          this.initialLoading = false;
        });
    },
    getReviewee() {
      if (this.type === "clinic") {
        return {
          name: this.reviews.results[0].clinic_info.clinic_name,
          image: this.reviews.results[0].clinic_info.picture,
          id: this.reviews.results[0].clinic_info.id,
          ratingLink: this.reviews.results[0].clinic_info.profile_link
        };
      } else if (this.type === "hospital") {
        return {
          name: this.reviews.results[0].hospital_info.hospital_name,
          image: this.reviews.results[0].hospital_info.picture,
          id: this.reviews.results[0].hospital_info.id,
          ratingLink: this.reviews.results[0].hospital_info.profile_link
        };
      } else if (this.type === "physician") {
        return {
          name:
            this.reviews.results[0].physician_info.full_name +
            (this.reviews.results[0].physician_info.title
              ? `, ${this.reviews.results[0].physician_info.title}`
              : ""),
          image: this.reviews.results[0].physician_info.picture,
          id: this.reviews.results[0].physician_info.id,
          ratingLink: this.reviews.results[0].physician_info.profile_link
        };
      } else if (this.type === "ohcp") {
        return {
          name:
            this.reviews.results[0].app_info.full_name +
            (this.reviews.results[0].app_info.title
              ? `, ${this.reviews.results[0].app_info.title}`
              : ""),
          image: this.reviews.results[0].app_info.picture,
          id: this.reviews.results[0].app_info.id,
          ratingLink: this.reviews.results[0].app_info.profile_link
        };
      }
      return {
        name: "D",
        id: 0,
        image: null,
        ratingLink: "www.dovemed.com"
      };
    },
    viewProfile(type = "reviewee") {
      const user = this.review;
      if (type === "reviewee") {
        if (user.reviewee.hasOwnProperty("is_virtual")) {
          this.routeProfile(type);
        } else {
          this.profile(type);
        }
      } else {
        this.profile(type);
      }
    },
    profile(type = "reviewee") {
      const user = this.review;
      if (type === "reviewee") {
        if (user.reviewee.hasOwnProperty("ext_ref_id")) {
          user["user_id"] = user.reviewee.ext_ref_id;
        } else {
          user["user_id"] = user.reviewee.id;
        }
        user["role"] = user.reviewee_role;
      } else {
        user["user_id"] = user.reviewer_id;
        user["role"] = user.reviewer_role;
      }
      if (user.role === "admin") {
        return;
      }
      this.loadingScreen = true;
      if (
        user.user_id === this.authUser.user.id &&
        user.role === this.authUser.user.role
      ) {
        this.routeToAuthProfile(this.authUser.user.role);
      } else {
        UserRepository.getOtherUserProfile(
          user.reviewee.hasOwnProperty("ext_ref_id") && type === "reviewee"
            ? { ext_ref_id: user.user_id, role: user.role }
            : { id: user.user_id, role: user.role },
          this.currentCircle.id
        )
          .then(res => {
            const data = {
              ...res.data.data.user_info,
              on_circle: res.data.data.on_circle,
              request_to_add: res.data.data.request_to_add,
              no_of_members: res.data.data.no_of_members,
              recommendations: res.data.data.no_of_recommendations,
              recommend: res.data.data.recommend,
              overall_rating: res.data.data.overall_rating
                ? res.data.data.overall_rating
                : res.data.data.rating,
              inPersonReview: res.data.data.in_person_visit,
              onlineReview: res.data.data.online_tele_medicine,
              myCirclesReview: res.data.data.my_circle
            };
            this.$store.commit("User/setViewUser", { data });
            switch (user.role) {
              case "doctor":
              case "physician":
                this.$router.push({
                  name: "ViewDoctorUpdates",
                  params: { id: user.user_id }
                });
                break;
              case "clinic_administrator":
                this.$router.push({
                  name: "ViewClinicAbout",
                  params: { id: user.user_id }
                });
                break;
              case "hospital_administrator":
                this.$router.push({
                  name: "ViewHos_adminAbout",
                  params: { id: user.user_id }
                });
                break;
              case "nfp":
                this.$router.push({
                  name: "ViewNfpAbout",
                  params: { id: user.user_id }
                });
                break;
              case "patient":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.user_id }
                });
                break;
              case "caregiver":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.user_id, role: 'caregiver' }
                });
                break;
              case "advocate":
                this.$router.push({
                  name: "ViewAdvocateAbout",
                  params: { id: user.user_id }
                });
                break;
              case "hospital":
                this.$router.push({
                  name: "HospViewAbout",
                  params: { id: user.user_id }
                });
                break;
              case "clinic":
                this.$router.push({
                  name: "ClinicViewAbout",
                  params: { id: user.user_id }
                });
              case "nfp_administrator":
                this.$router.push({
                  name: "ViewNfpAdminAbout",
                  params: { id: user.user_id }
                });
                break;
              default:
                break;
            }
          })
          .catch(err => {
            this.loadingScreen = false;
          });
      }
    },
    routeProfile(type = "reviewee") {
      this.loadingScreen = true;
      let info = {};
      if (type === "reviewee") {
        info = this.review.reviewee;
        if (!info.hasOwnProperty("role")) {
          info["role"] = this.review.reviewee_role;
        }
      } else {
        info = this.review.reviewer[0];
        if (!info.hasOwnProperty("role")) {
          info["role"] = this.review.reviewer_role;
        }
      }
      if (
        Number(info.ext_ref_id) === this.authUser.user.ext_ref_id &&
        info.role === this.authUser.user.role
      ) {
        switch (info.role) {
          case "hospital_administrator":
            this.$router.push({ name: "HosAbout" });
            break;
          case "hcp":
            this.$router.push({ name: "HcpAbout" });
            break;
          case "nfp_administrator":
            this.$router.push({ name: "NFPAbout" });
            break;
          case "clinic_administrator":
            this.$router.push({ name: "ClinicAbout" });
            break;
          case "doctor":
            this.$router.push({ name: "DocUpdates" });
            break;
          case "Business":
            break;
          default:
            this.$router.push({ name: "DocUpdates" });
            break;
        }
      } else {
        let data = { ...info, role: info.role };
        // console.log(data, "data in routing card")
        switch (info.role) {
          case "physician":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "doctor",
                  id: info.my_circles_id,
                  ext_ref_id: null
                })
              : this.viewEntityProfile({
                  ...info,
                  role: "doctor",
                  id: info.id
                });
            break;
          case "doctor":
            // console.log("doctor")
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "doctor",
                  id: info.my_circles_id,
                  ext_ref_id: null
                })
              : this.viewEntityProfile({
                  ...info,
                  role: "doctor",
                  id: info.id
                });
            break;
          case "providers":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "doctor",
                  id: info.my_circles_id,
                  ext_ref_id: null
                })
              : data.ext_ref_id
              ? this.viewEntityProfile({ ...info, role: "doctor" })
              : this.viewProfile({
                  ...info,
                  role: "doctor",
                  id: info.id
                });
            break;
          case "other":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "hcp",
                  id: info.my_circles_id,
                  ext_ref_id: null
                })
              : this.viewEntityProfile({ ...info, role: "hcp" });
            break;
          case "hcp":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "hcp",
                  id: info.my_circles_id,
                  ext_ref_id: null
                })
              : this.viewEntityProfile({ ...info, role: "hcp" });
            break;
          case "hcp_administrator":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "hcp",
                  id: info.my_circles_id,
                  ext_ref_id: null
                })
              : this.viewEntityProfile({ ...info, role: "hcp" });
          case "hospital":
            info.id
              ? data.my_circles_id
                ? this.viewProfile({
                    ...info,
                    role: "hospital_administrator",
                    id: info.my_circles_id,
                    ext_ref_id: null
                  })
                : this.viewEntityProfile({ ...info, role: "hospital" })
              : data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "hospital_administrator",
                  id: info.my_circles_id,
                  ext_ref_id: null
                })
              : this.viewProfile({
                  ...info,
                  role: "hospital_administrator",
                  id: info.id
                });
            break;
          case "hospital_administrator":
            info.id
              ? data.my_circles_id
                ? this.viewProfile({
                    ...info,
                    role: "hospital_administrator",
                    id: info.my_circles_id,
                    ext_ref_id: null
                  })
                : this.viewEntityProfile({ ...info, role: "hospital" })
              : data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "hospital_administrator",
                  id: info.my_circles_id,
                  ext_ref_id: null
                })
              : this.viewProfile({
                  ...info,
                  role: "hospital_administrator",
                  id: info.id
                });
            break;
          case "clinic":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "clinic",
                  id: info.my_circles_id,
                  ext_ref_id: null
                })
              : this.viewEntityProfile(data);
            break;
          case "clinic_administrator":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "clinic",
                  id: info.my_circles_id,
                  ext_ref_id: null
                })
              : this.viewEntityProfile({ ...info, role: "clinic" });
            break;
          case "nfp":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "nfp",
                  id: info.my_circles_id,
                  ext_ref_id: null
                })
              : this.viewEntityProfile(data);
            break;
          case "nfp_administrator":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "nfp",
                  id: info.my_circles_id,
                  ext_ref_id: null
                })
              : this.viewEntityProfile({ ...info, role: "nfp" });
            break;
          case "Business":
            this.loadingScreen = true;
            break;
        }
      }
    }
  }
};
</script>

<style lang="scss">
.dovemed-custom-pagination .ant-pagination-item-active {
  background: #2a71d4;
}

.dovemed-custom-pagination .ant-pagination-item-active a {
  color: #ffffff !important ;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
}

.dovemed-custom-pagination .ant-pagination-item-active a:hover {
  color: #ffffff !important;
}
</style>

<style lang="scss" scoped>
.mobile-top {
  @media only screen and (max-width: 767px) {
    -webkit-box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.1);
    box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.1);
    padding: 24px;
    border-radius: 0px;
  }
}
.back-button {
  font-family: "Lato";
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 27px;
  text-align: start;
}

.profile-img2 {
  width: 70px;
  height: 70px;
  border-radius: 50%;
}

.text-name {
  font-weight: 700;
  font-size: 16px;
  color: #0f1734;
  margin-left: 16px;
  margin-bottom: 4px;
  text-transform: capitalize;
}
.radio-group {
  @media only screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}

.text-day {
  font-weight: 400;
  font-size: 12px;
  color: #94a3b8;
  margin-left: 16px;
  margin-bottom: 0px;
}

.page-container {
  @media only screen and (max-width: 767px) {
    padding: 16px;
    padding-top: 0px;
  }
}

.page-info {
  margin-top: 30px;
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 767px) {
    margin-top: 24px;
    margin-bottom: 16px;
  }
}

.result-length {
  font-weight: 700;
  font-size: 20px;
  color: #0f1734;
}
.detail-container {
  display: flex;
  background-color: #f1f5f9;
  height: 70px;
  align-items: center;
  padding: 0px 40px;
  @media only screen and (max-width: 900px) {
    display: none;
  }
}
.detail-container-mobile {
  display: flex;
  background-color: #f1f5f9;
  height: 70px;
  align-items: center;
  justify-content: center;
  padding: 0px 40px;
  margin-top: 24px;
  @media only screen and (min-width: 901px) {
    display: none;
  }
}
.review-text {
  font-weight: 700;
  font-size: 16px;
  color: #0f1734;
  margin-left: 8px;
}

.star-container {
  width: 24px;
  height: 24px;
  border-radius: 2px;
}

.review-subtext {
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: #94a3b8;
  margin-top: 2px;
  text-align: center;
  white-space: nowrap;
}

.checkbox-text {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
  margin-right: 48px;
}
.sort-text {
  font-weight: 400;
  font-size: 14px;
  color: #0f1734;
  margin-bottom: 0px;
  cursor: pointer;
  white-space: nowrap;
  margin-left: 20px;
}
.spinnerContainer-post {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba($color: #000000, $alpha: 0.2);
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/reviews/IndividualReviews.vue